import { message, Spin } from 'antd';
import React, { useCallback, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import EditButton from '../../../../components/EditButton/EditButton';
import queries from '../../../../queries/queries';
import editFacilityTariff from '../../../../requests/editFacilityTariff';
import styles from './Tariff.module.scss';

const Tariff = ({ tariff, facility }) => {
  const queryClient = useQueryClient();
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState();
  const userCanChange = useSelector(
    (store) => store.authentication.userInfo.CanCreateOffice
  );
  const clickEdit = () => {
    if (!isEdit) {
      setIsEdit(true);
      setInputValue(tariff.value);
    } else {
      setIsEdit(false);
    }
  };

  const clickSave = useCallback(async () => {
    if (inputValue > 99999.99 || inputValue <= 0) {
      message.error('Значение должно быть больше 0 и меньше 99999.99', 5);
      return;
    }
    setLoading(true);
    await editFacilityTariff({ ...tariff, value: +inputValue }, facility);
    queryClient.invalidateQueries(queries.facilityTariffs);
    setIsEdit(false);
    setLoading(false);
  }, [tariff, facility, inputValue, queryClient]);

  return (
    <Spin spinning={loading}>
      <div className={styles.tariff}>
        <div className={styles.name}>{tariff.tariff.name}</div>
        <div className={styles.value}>
          <span className={styles.tariffOpacity}>Тариф </span>
          {isEdit ? (
            <input
              type="number"
              className={styles.inputTariff}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  clickSave();
                }
              }}
            />
          ) : (
            <span className={styles.amount}>{tariff.value}</span>
          )}
          {userCanChange && (
            <EditButton
              isEdit={isEdit}
              clickEdit={clickEdit}
              clickSave={clickSave}
            />
          )}
        </div>
      </div>
    </Spin>
  );
};

export default Tariff;
